import {makeResource} from 'app/infrastructure/repository'
import { Ride } from './_models';

const RIDE_ENDPOINT = 'rides';

export default makeResource<Ride>(RIDE_ENDPOINT);

